import InvoiceDescription from 'components/Help/InvoiceDescription/InvoiceDescription'

export default InvoiceDescription
